module.exports = __webpack_public_path__ + "img/SCB.09fb6b8c.svg";